import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Box,
  Badge,
  Grid,
  Menu,
  MenuItem,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import MoreIcon from '@mui/icons-material/MoreVert';
// import { getProfile } from 'redux/actions/SettingsAction';
import { addMagicToken } from 'redux/actions/authAction';
import { appBarStyle, appToolBarStyle } from './HeaderStyle';
import profile from 'assets/images/profileImg.svg';
import notification from 'assets/images/notificationIcon.svg';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';

function Header(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(null);
  const [pageName, setPageName] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  let tableData = useSelector(
    (state) => state?.userNotificationCount?.userNotificationCount?.data
  );
  const userId = localStorage.getItem('userId');
  const filterData = {
    id: ''
  }

  let user = {
    userId: userId,
  };

  useEffect(() => {
    const data = window.location.href;
    const paramsVal = data?.split('/')[3];
    if(paramsVal === 'notification'){
      tableData = {...tableData, notificationsCount:0}
    }else{
      // dispatch(getNotificationCount(filterData));
    }
    setPageName(paramsVal?.split('?')[0]);
  }, [location]);

  const handleOnError = (e) => {
    e.target.src = profile;
  };

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isPopoverMenuOpen = Boolean(popoverOpen);

  const handlePopoverMenuOpen = (event) => {
    setPopoverOpen(event.currentTarget);
  };

  const handlePopoverMenuClose = () => {
    setPopoverOpen(null);
  };

  const handleProfileMenuOpen = () => {
    window.location.replace('/settings');
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const onNotification = () => {
    window.location.replace('/notification');
  };

  const onHandleSwitch = () => {
    dispatch(addMagicToken());
  };

  function generateGreeting(pageName) {
    switch (pageName) {
      case 'dashboard': {
        const currentTime = new Date();
        const hours = currentTime.getHours();

        if (hours >= 5 && hours < 12) {
          return 'Good Morning';
        } else if (hours >= 12 && hours < 17) {
          return 'Good Afternoon';
        } else {
          return 'Good Evening';
        }
      }
      case 'sub-vendor':
        return 'Sub Vendor';
      case 'citymanager':
        return 'City Manager';
      case 'regionaluser':
        return 'Regional User';
      case 'report':
        return 'Reports';
      case 'payment':
      case 'newPayment':
      case 'paymentdetails':
        return 'Settlement';

      default:
        return pageName.charAt(0).toUpperCase() + pageName.slice(1) || 'Hello';
    }
  }

  const greeting = generateGreeting(pageName);

  const userProfile = JSON?.parse(localStorage.getItem('user'));

  const dashboardRoleEnum = roleAndPermissionEnum.dashboard

  return (
    <div>
      <Box>
        <AppBar position="static" style={appBarStyle}>
          <Toolbar style={appToolBarStyle}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={props.handelOnlyOnMobile}
              sx={{ mr: 2, display: { sm: 'none', xs: 'flex' } }}
            >
              <MenuIcon />
            </IconButton>
            <Grid container direction="row" className="height86 justifyBetween">
              <Grid item xs={5}>
                {pageName === 'dashboard' && (
                  <Typography
                    component={'h6'}
                    className="colorGrey font14 fw600"
                    variant="body2"
                  >
                    <p className="marginBlock0">
                      Hi,{userProfile?.subRole}
                    </p>
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  className="fw600"
                  noWrap
                  component="div"
                >
                  <p className={'font20 fontMedium marginBlock0'}>{greeting}</p>
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
}

export default Header;
